import { Injectable, inject } from '@angular/core';
import { Router } from '@angular/router';
import { AuthenticationService } from '../auth/authentication.service';
import { MsalService } from '@azure/msal-angular';
import { RouteHandlerService } from './route-handler.service';
import { LoggerService } from './logger.service';

@Injectable({
  providedIn: 'root'
})
export class AppInitService {
  private authService = inject(AuthenticationService);
  private msalService = inject(MsalService);
  private router = inject(Router);
  private routeHandler = inject(RouteHandlerService);
  private logger = inject(LoggerService);

  async initializeApp(): Promise<void> {
    try {
      const hasValidSession = await this.authService.checkSessionValidity();

      if (!hasValidSession) {
        const account = await this.msalService.instance.getActiveAccount();
        if (!account) {
          const accounts = await this.msalService.instance.getAllAccounts();
          if (accounts && accounts.length > 0) {
            await this.msalService.instance.setActiveAccount(accounts[0]);
          }
        }

        const restored = await this.authService.restoreSessionFromMsal();
        if (!restored) {
          const currentUrl = this.router.url;
          if (!currentUrl.includes('/login')) {
            this.router.navigate(['/login']);
          }
        } else {
          this.routeHandler.handleSuccessfulAuth();
        }
      }
    } catch (error) {
      this.logger.error('Error during app initialization', error);

      const currentUrl = this.router.url;
      if (!currentUrl.includes('/login')) {
        this.router.navigate(['/login']);
      }
    }
  }

  async handlePageReload(): Promise<boolean> {
    try {
      const token = this.authService.getToken();
      if (token) {
        return true;
      }

      const restored = await this.authService.restoreSessionFromMsal();
      return restored;
    } catch (error) {
      this.logger.error('Error handling page reload', error);
      return false;
    }
  }
}
